import React, {useState} from 'react';
import Autosuggest, {SuggestionsFetchRequestedParams} from 'react-autosuggest';
import {useFormikContext} from 'formik';
import {apiClient} from "../../../utils/ApiClient";
import '../../common/form/css/ClientInput.css';
import ElogSelect, {Option} from "../../common/form/ElogSelect";

export interface SmartAccountsVendor {
    id: string;
    name: string;
    regCode: string | null;
    vatNumber: string | null;
    country: string | null;
    region: string | null;
}

export const purchaseRegionOptions: Option[] = [
    {value: '', label: 'Määramata'},
    {value: 'EE', label: 'Eesti allhankija (40507, KM 24%)'},
    {value: 'EU', label: 'EL allhankija (40508, KM 24% pöördmaks)'},
    {value: 'OTHER', label: 'Kolmanda riigi vedaja (40515, KM 0%)'},
];

const SmartAccountsVendorInput: React.FC = () => {
    const formik = useFormikContext<any>();

    const [query, setQuery] = useState<string | null>(null);
    const [suggestions, setSuggestions] = useState<SmartAccountsVendor[]>([]);
    const [error, setError] = useState<string>('');

    const linkedName: string = formik.values.smartaccountsName ?? '';
    const isLinked = !!formik.values.smartaccountsId;

    const fetchVendors = async (search: string) => {
        try {
            const response = await apiClient.get(`smartaccounts/vendors?search=${encodeURIComponent(search)}`);
            setSuggestions(response.data);
            setError('');
        } catch (e) {
            setSuggestions([]);
            setError('Smart Accountsi hankijate otsing ebaõnnestus');
        }
    };

    const onSuggestionsFetchRequested = ({value}: SuggestionsFetchRequestedParams) => {
        if (value.length > 1) {
            fetchVendors(value);
        } else {
            setSuggestions([]);
        }
    };

    const onSuggestionSelected = (event: React.FormEvent<any>, {suggestion}: { suggestion: SmartAccountsVendor }) => {
        formik.setFieldValue('smartaccountsId', suggestion.id);
        formik.setFieldValue('smartaccountsName', suggestion.name);
        if (suggestion.region) {
            formik.setFieldValue('purchaseRegion', suggestion.region);
        }
        setQuery(null);
    };

    const unlink = () => {
        formik.setFieldValue('smartaccountsId', '');
        formik.setFieldValue('smartaccountsName', '');
        setQuery('');
    };

    const renderSuggestion = (suggestion: SmartAccountsVendor) => (
        <div>
            {suggestion.name}
            {(suggestion.regCode || suggestion.country) && (
                <span style={{color: '#888'}}> ({[suggestion.regCode, suggestion.country].filter(Boolean).join(', ')})</span>
            )}
        </div>
    );

    return (
        <>
            <tr>
                <th>Smart Accounts hankija:</th>
                <td>
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={() => setSuggestions([])}
                        onSuggestionSelected={onSuggestionSelected}
                        getSuggestionValue={(suggestion: SmartAccountsVendor) => suggestion.name}
                        renderSuggestion={renderSuggestion}
                        inputProps={{
                            value: query ?? linkedName,
                            placeholder: 'Otsi nime või registrikoodi järgi',
                            className: 'text',
                            onChange: (_, {newValue}) => setQuery(newValue),
                            onBlur: () => setQuery(null),
                        }}
                        theme={{
                            container: 'react-autosuggest__container',
                            suggestionsContainer: (suggestions.length > 0)
                                ? 'react-autosuggest__suggestions-container visible'
                                : 'react-autosuggest__suggestions-container',
                            suggestionsList: 'react-autosuggest__suggestions-list',
                            suggestion: 'react-autosuggest__suggestion',
                            suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
                        }}
                    />
                    <div>
                        {isLinked
                            ? <>Seotud <button type="button" onClick={unlink} style={{background: 'none', border: 0, padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>Eemalda seos</button></>
                            : <span style={{color: 'red'}}>Sidumata – ostuarveid Smart Accountsi ei saadeta</span>}
                    </div>
                    {error && <div className="error">{error}</div>}
                </td>
            </tr>
            <ElogSelect label="Hankija tüüp" name="purchaseRegion" options={purchaseRegionOptions}/>
        </>
    );
};

export default SmartAccountsVendorInput;
